// extracted by mini-css-extract-plugin
module.exports = {"root":"MapSectionClient_root__mt1vj","isDark":"MapSectionClient_isDark__T2cdD"};